import {DestinationType} from 'graphql-client/__generated/graphqlGlobalTypes';
import * as net from 'util/Net';

import {EventSubscriptionGraphQL} from '../../graphql-fragments/events/__generated/EventSubscriptionGraphQL';

export const EVENT_SUBSCRIPTIONS_URL = '/event-subscriptions';

export interface CreateEventbridgeSubscriptionArgs {
  destinationType: DestinationType;
  awsAccountId: string;
  awsRegion: string;
  eventTypes: Array<string>;
  eventBusName: string;
}

export function createEventbridgeSubscription(
  data: CreateEventbridgeSubscriptionArgs
): Promise<{eventSubscription: EventSubscriptionGraphQL}> {
  return net.postJSONPromise({
    url: '/1/api/event-subscriptions',
    data,
  });
}

export function deleteEventSubscription(eventSubscriptionId: string): Promise<{}> {
  return net.deletePromise({
    url: `/1/api/event-subscriptions/${eventSubscriptionId}`,
  });
}

export interface UpdateEventSubscriptionArgs {
  eventTypes: Array<string>;
  paused: boolean;
}

export function updateEventSubscription(
  eventSubscriptionId: string,
  data: UpdateEventSubscriptionArgs
): Promise<{eventSubscription: EventSubscriptionGraphQL}> {
  return net.patchJSONPromise({
    url: `/1/api/event-subscriptions/${eventSubscriptionId}`,
    data,
  });
}
